import Palette from '../theme/shared/palette.js';

const mapColors = ({ theme , color  })=>{
    return color === "grey" && theme.colors["Level 1"] || color === "blue" && theme.colors.Color2_75 || color === "red" && theme.colors.Color1 || color === "black" && theme.colors.Foreground || color === "white" && "#ffffff" || color === "yellow" && "#ffc700" || theme.colors[color] || color;
};
const mapColorsHover = ({ theme , color  })=>{
    return color === "grey" && theme.colors["Level 3"] || color === "blue" && "#182d99" || color === "red" && "#ba264d" || color === "yellow" && "#eda210" || color === "black" && theme.colors.Background || color === "white" && Palette.grey[25] || theme.colors[color] || color;
};

export { mapColors, mapColorsHover };
